import { DIValidators } from "@/core/@types/types";
import { IF360Validator } from "@/core/validators/F360Validator";
import { diContainer } from "@/core/di";
import { F360PageTitles } from "@/core/router/F360PageTitles";
import type { RouteRecordRaw } from "vue-router";

export enum ContabilPortalComunicaoRouter {
  base = "index"
}

const temAcessoAoContabil = (): boolean => {
  return diContainer
    .get<IF360Validator>(DIValidators.ACESSO_CONTABIL)
    .handleValidation();
};

export const comunicacaoRoutes: Array<RouteRecordRaw> = [
  {
    path: "portal-comunicacao",
    component: () =>
      import("@/features/contabil/comunicacao/ComunicacaoBase.vue"),
    name: ContabilPortalComunicaoRouter.base,
    meta: {
      title: F360PageTitles.PortalComunicacao,
      isForbidden: () => !temAcessoAoContabil()
    }
  }
];
